// extracted by mini-css-extract-plugin
export default {"container":"j1-z"};